export default class Videos {
  static selectorString() {
    return '.Bookmark';
  }

  constructor(rootNode) {
    /* global acc_ajax */
    const videoId = jQuery(rootNode).attr('id');
    jQuery('.bookmark-icon-wrap', jQuery(rootNode)).each(function () {
      const bookmark = jQuery(this);
      bookmark.click(function (e) {
        let chapterId = null;
        if (bookmark.parent().attr('id')) {
          chapterId = bookmark.parent().attr('id');
        }
        e.preventDefault();
        jQuery.ajax({
          url: acc_ajax.ajax_url,
          type: 'POST',
          dataType: 'jsonp',
          jsonp: 'jsonp_callback',
          timeout: 50000,
          retryLimit: 3,
          data: {
            action: 'bookmark',
            video_id: videoId,
            chapter_id: chapterId,
          },
          success: function (response) {
            if (response.status === 'saved') {
              bookmark.addClass('saved');
            } else {
              bookmark.removeClass('saved');
            }
          },
          // eslint-disable-next-line handle-callback-err
          error: function (error) {
            // toDo log?
          },
        });
      });
    });

    jQuery('.icon-arrow-down').not('.down').on('click', function () {
      jQuery('.previews-container').fadeIn();
      jQuery('.icon-arrow-down').hide();
      jQuery('.down').show().css('transform', 'rotate(180deg)');
    });

    jQuery('.down').on('click', function () {
      jQuery('.previews-container').fadeOut();
      jQuery('.down').hide();
      jQuery('.icon-arrow-down').not('.down').show();
    });
  }
}
